/** @jsx jsx */
import { jsx, css } from '@emotion/react'
import { Grid } from '@mui/material'
import DashboardNextDispatcher from '@reducers/dashboardNext/dispatcher'
import { ReduxState } from '@reducers/index'
import _ from 'lodash'
import React from 'react'
import { useAsyncFetch } from 'react-hooks-async-handlers'
import { useDispatch, useSelector } from 'react-redux'
import { RendererStatusSplit } from 'react-renderer-status-split'
import Loader from '../../../components/Loader'
import { ReduxDispatch } from '../../../typings/ReduxDispatch'
import SectionContainer from '../components/elements/SectionContainer'
import SectionTitle from '../components/elements/SectionTitle'
import Path from './Path'
import DistanceMeasurementSwitch from './components/DistanceMeasurementSwitch'
import StepsPathMetrics from './components/StepsPathMetrics'

function StepsPath({ challenge }) {
  return (
    <SectionContainer
      css={css`
        padding: 10px 10px 0;
      `}
    >
      <div
        css={css`
          padding-left: 30px;
          min-width: 348px;
          max-width: 348px;
        `}
      >
        <Grid container justifyContent={'space-between'}>
          <SectionTitle
            css={css`
              margin-bottom: 15px;
            `}
          >
            Company progress map
          </SectionTitle>

          <div>
            <Grid container alignItems={'center'}>
              <DistanceMeasurementSwitch />
            </Grid>
          </div>
        </Grid>

        <div>
          {challenge && <StepsPathMetrics info={challenge} />}

          <Path stepsPath={challenge} />
        </div>
      </div>
    </SectionContainer>
  )
}

export default StepsPath
